export default __webpack_public_path__ + "static/media/audio_40_violin.4c85bb10.mp3";